import { Languages, SubmissionType as QuestionerSubmissionType } from "@cs124/questioner-types";
import { Literal, Record, String } from "runtypes";
export const CompleteSubmissionType = QuestionerSubmissionType.Or(Literal("STUMPER"));
export const QuestionCoordinates = Record({
  language: Languages,
  path: String,
  author: String
});
export const SubmissionCoordinates = QuestionCoordinates.And(
  Record({
    submissionType: CompleteSubmissionType
  })
);
export const DeadlineCoordinates = QuestionCoordinates.And(
  Record({
    submissionType: CompleteSubmissionType
  })
);
//# sourceMappingURL=coordinates.js.map
